<template>
    <section class="slice slice-profiles slice-profiles--default" aria-label="profiles" data-testid="slice-profiles-default">
        <div class="slice-content">
            <PrismicRichText :field="slice.primary.title" class="slice-title" data-testid="slice-profiles-title" />
            <PrismicRichText :field="slice.primary.description" class="slice-description" data-testid="slice-profiles-description" />
            <div class="slice-body">
                <ProfilesCarousel v-if="profiles?.length" :items="profiles" />
            </div>
            <div v-if="ctaWebLink" class="text-center joy-mt-8">
                <VJoyButton :href="$withLocalePrefix(ctaWebLink.url)" :target="ctaWebLink.target" variant="main" data-testid="slice-profiles-cta">
                    {{ ctaWebLink.text }}
                </VJoyButton>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed, ref} from 'vue';
    import {isFilled} from '@prismicio/helpers';
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {ProfilesSlice} from '@prismicio-types';
    import {useAsyncData} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import ProfilesCarousel from '../components/ProfilesCarousel.vue';
    import {searchProfiles} from '../composables/search/useSearchProfiles.js';

    type ProfilesDefaultVariation = Extract<ProfilesSlice, {variation: 'default'}>;

    const props = defineProps(getSliceComponentProps<ProfilesDefaultVariation>());

    const ctaWebLink = computed(() => {
        const cta = props.slice.primary.cta;
        if (isFilled.link(cta) && cta.link_type === 'Web') {
            return {url: cta.url, target: cta.target, text: cta.text ?? ''};
        }
        return null;
    });

    const aliases = ref(props.slice.items.map((item) => `/profile/${item.profileAlias}`));
    const {data: profiles} = await useAsyncData(
        `slice-profiles-${props.slice.id}`,
        () => searchProfiles({profileIdOrSeoUrl: aliases.value, hiddenProfiles: true}),
        {
            deep: true,
        },
    );
</script>
